var front_app = front_app || {};
front_app = {
	body: $(document.body),
	Window: $(window),
    is_requesting: false,
    user:{
        userLogin: function () {
            $('.js-login-form').on('submit', function (e) {
                e.preventDefault();
                var _self = $(this);
                var btn_submit = _self.find('button[type="submit"]');
                var btn_submit_text = btn_submit.html();
                btn_submit.html('Đang xử lý...');

                $.ajax({
                    url: base_url + '/api/user/login',
                    data: $('.js-login-form').serialize(),
                    type: 'POST',
					dataType: 'json',
					xhrFields: {
						withCredentials: true
					},
                    success:function(){
                        btn_submit.html(btn_submit_text);
                    }
                });
            });

            $('.js-login-form-popup').on('submit', function (e) {
                e.preventDefault();
                var _self = $(this);
                var btn_submit = _self.find('button[type="submit"]');
                var btn_submit_text = btn_submit.html();
                btn_submit.html('Đang xử lý...');

                $.ajax({
                    url: base_url + '/api/user/login',
                    data: $('.js-login-form-popup').serialize(),
                    type: 'POST',
                    dataType: 'json',
                    success:function(){
                        btn_submit.html(btn_submit_text);
                    }
                });
            });
        },
        userRegister: function () {
            $('.js-register-form').on('submit', function (e) {
                e.preventDefault();
                var _self = $(this);
                var btn_submit = _self.find('button[type="submit"]');
                var btn_submit_text = btn_submit.html();
                btn_submit.html('Đang xử lý...');
                $.ajax({
                    url: base_url + '/api/user/register',
                    data: $('.js-register-form').serialize(),
                    type: 'POST',
					dataType: 'json',
					xhrFields: {
						withCredentials: true
					},
                    success:function(){
                        btn_submit.html(btn_submit_text);
                    }
                });
            });

            $('.js-register-form-popup').on('submit', function (e) {
                e.preventDefault();
                var _self = $(this);
                var btn_submit = _self.find('button[type="submit"]');
                var btn_submit_text = btn_submit.html();
                btn_submit.html('Đang xử lý...');

                $.ajax({
                    url: base_url + '/api/user/register',
                    data: $('.js-register-form-popup').serialize(),
                    type: 'POST',
                    dataType: 'json',
                    success:function(){
                    	btn_submit.html(btn_submit_text);
                    }
                });
            });
        },
        forgotPassword: function () {
            var action_url, phone_or_email;

            // send email/sdt để lấy mã xác nhận
            $('.js-forget-password-first-step').on('submit', function (e) {
                e.preventDefault();

                var _self = $(this);
                action_url = _self.attr('data-action');
                phone_or_email = _self.find('.js-input-phone-or-email').val();
				var _button_text = _self.find('.js-forgot-password-next-step').html();
                _self.find('.js-forgot-password-next-step').html('Đang xử lý...');
                var data_next_step = _self.find('.js-forgot-password-next-step').attr('data-next-step');

                $.ajax({
                    url: base_api_url+ '/user/send-token',
                    data: _self.serialize(),
                    // data: {
                    //     phone_or_email: phone_or_email,
					// 	action: 'forget_password'
                    // },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
						_self.find('.js-forgot-password-next-step').html(_button_text);
                        if (data.data_code == 200) {
                            $('.js-forgot-password-step.active').addClass('deactive');
                            $('.js-forgot-password-step.step_' + data_next_step).find('.js-alert-message').html(data.message);
                            setTimeout(function () {
                                $('.js-forgot-password-step').removeClass('active');
                                $('.js-forgot-password-step.step_' + data_next_step).addClass('active');
                            }, 100);

							$('.js-btn-resend-token').addClass('disabled').prop('disabled', true);
							var _time = new Date();
							var _second = 120;
							_time.setSeconds(_time.getSeconds() + _second);

							$('.js-btn-resend-token .js-time-expired').countdown(_time).on('update.countdown', function(event) {
								_second--;
								$(this).html('('+_second+'s)');
							}).on('finish.countdown', function(event){
								// DONE
								$(this).html('');
								$('.js-btn-resend-token').removeClass('disabled').removeAttr('disabled');
							});
                        }
                    }
                });
            });

            // verify mã xác nhận đúng hay không
            $('.js-forget-password-second-step').on('submit', function (e) {
                e.preventDefault();

                var _self = $(this);
                var verify_code = _self.find('.js-input-verify-code').val();
                var data_next_step = _self.find('.js-forgot-password-next-step').attr('data-next-step');

                $.ajax({
                    url: base_api_url+ '/user/verify-token',
                    data: {
                        verify_code: verify_code,
                        phone_or_email: phone_or_email
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.data_code == 200) {
                            $('.js-forgot-password-step.active').addClass('deactive');
                            setTimeout(function () {
                                $('.js-forgot-password-step').removeClass('active');
                                $('.js-forgot-password-step.step_' + data_next_step).addClass(
                                    'active'
                                );
                            }, 100);
                        }
                    }
                });
            });

            $('.js-forget-password-third-step').on('submit', function (e) {
                e.preventDefault();

                var _self = $(this);
                var password = _self.find('.js-newpassword').val();
                var cf_password = _self.find('.js-confirm-newpassword').val();
				var verify_code = $('.js-input-verify-code').val();
                if (password != cf_password) {
                    alert('Mật khẩu xác nhận không đúng');
                    return;
                }
                var data_next_step = _self.find('.js-forgot-password-next-step').attr('data-next-step');
                $.ajax({
                    url: base_api_url+'/user/update-password',
                    data: {
                        verify_code: verify_code,
                        password: password,
                        cf_password: cf_password,
                        phone_or_email: phone_or_email
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.data_code == 200) {
                            $('.js-forgot-password-step.active').addClass('deactive');
                            setTimeout(function () {
                                $('.js-forgot-password-step').removeClass('active');
                                $('.js-forgot-password-step.step_' + data_next_step).addClass(
                                    'active'
                                );
                            }, 100);
                        }
                    }
                });
            });

            // gửi lại mã xác nhận trường hợp không nhận được, hay lỡ xóa hay sao đó
            $('.js-btn-resend-token').on('click', function (e) {
                e.preventDefault();
				var self = $(this);
				action_url = self.attr('data-action-url');
				phone_or_email = $('.js-input-phone-or-email').val();
				if (!phone_or_email || !validatePhone(phone_or_email)) {
                    toastr.error(
                        'Vui lòng nhập đúng Format số điện thoại: Vd 0981234567 hoặc 012341234567',
                        'Lỗi'
                    );
                    return;
                }
                // business logic...
                $.ajax({
                    url: action_url,
                    data: {
                        phone_or_email: phone_or_email,
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
						if(data.code == 200){
							self.addClass('disabled').prop('disabled', true);
							var _time = new Date();
							var _second = 120;
							_time.setSeconds(_time.getSeconds() + _second);

							self.find('.js-time-expired').countdown(_time)
							.on('update.countdown', function(event) {
								_second--;
								$(this).html('('+_second+'s)');
							})
							.on('finish.countdown', function(event){
								// DONE
								$(this).html('');
								self.removeClass('disabled').removeAttr('disabled');
							});
						}
                    }
                });
			});

			$('.js-forget-password-second-step').find('.js-btn-back').on('click', function(e){
				e.preventDefault();

				$('.js-forgot-password-step').removeClass('active');
				$('.js-forgot-password-step.step_verify_account').addClass('active');
			});

        },
        verifyAccount: function () {
            var phone_number = $('.js-input-phone').val();

            $('.js-btn-get-verify-code').on('click', function (e) {
                e.preventDefault();

				var _self = $(this);
				if(front_app.is_requesting) return;
				front_app.is_requesting = true;

                phone_number = $('.js-input-phone').val();
                var next_step = _self.attr('data-step-next');
                var data_action_url = _self.attr('data-action-url');
                if (!phone_number || !validatePhone(phone_number)) {
                    toastr.error(
                        'Vui lòng nhập đúng Format số điện thoại: Vd 0981234567 hoặc 012341234567',
                        'Lỗi'
                    );
                    return;
                }

				var formData = new FormData(_self.closest('form')[0]);
			    formData.append('action', 'verify');
			    formData.append('phone_or_email', phone_number);

                $.ajax({
                    url: data_action_url,
                    data: formData,
                    processData: false,
				    contentType: false,
                    type: 'POST',
                    success: function (data) {
						front_app.is_requesting = false;
                        if (data.data_code == 200) {
                            $('.js-verify-step').removeClass('active');
                            $('.js-verify-step-input-code').addClass('active');
                            $('.js-verify-step-input-code').find('.js-alert-message').html(data.message);
						}

						$('.js-verify-step-input-code .js-btn-get-verify-code').addClass('disabled').prop('disabled', true);
						var _time = new Date();
						var _second = 120;
						_time.setSeconds(_time.getSeconds() + _second);

						$('.js-verify-step-input-code .js-time-expired').countdown(_time)
						.on('update.countdown', function(event) {
							_second--;
							$(this).html('('+_second+'s)');
						})
						.on('finish.countdown', function(event){
							// DONE
							$(this).html('');
							$('.js-verify-step-input-code .js-btn-get-verify-code').removeClass('disabled').removeAttr('disabled');
						});
                    }
                });
            });

            $('.js-btn-verify').on('click', function (e) {
                e.preventDefault();

                var _self = $(this);
                var data_action_url = _self.attr('data-action-url');
                var verify_code = $('.js-input-verify-code').val();
                var redirect_to = $('#redirect_to').val();
                phone_number = $('.js-input-phone').val();

                if (!verify_code) {
                    toastr.error('Bạn hãy nhập mã xác nhận để tiếp tục.', 'Lỗi');
                    return;
                }

                $.ajax({
                    url: data_action_url,
                    data: {
                        verify_code: verify_code,
                        phone_or_email: phone_number,
                        action: 'verify',
                        redirect_to: redirect_to
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if (data.data_code == 200) {
                            $('.js-verify-step').removeClass('active');
                            $('.js-verify-step-complete').addClass('active');
                            localStorage.setItem('verified', 1);
                        }
                    }
                });
            });

            // var from = $('.js-verify-input-phone').attr('data-from-page');
            // if(from == 'r' && phone_number != ''){
            //     $('.js-btn-get-verify-code').trigger('click');
			// }
        },
		lastActivity: function () {
            if($('.js-author-online-status').length == 0) return;

            $.ajax({
                url: base_url + '/api/user/check/online',
                data: {
                    user_id: $('.js-author-online-status').attr('author_id') || 0,
                },
                type: 'POST',
                dataType: 'json'
            });
        },
		rating: function () {
			$('.js-section-rating-list').on('click', '.page-link', function(e){
				e.preventDefault();

				var href = $(this).attr('href');
				var broker_id = $('.js-section-rating-list').attr('data-broker-id');
				var paged = common_app.search.getParameterByName('page', href);
				paged = !isNaN(paged) ? paged: 1;
				$.ajax({
					url: base_api_url + '/user/reviews',
					data: {
						review_page: paged,
						broker_id: broker_id,
					},
					type: 'POST',
					dataType: 'json'
				});
			});
		},
        logout:function(){
            $('.js-logout-wrap a').on('click', function(event){
                event.preventDefault();
                var _self = $(this);
                var logout_url = _self.attr('href');
                localStorage.removeItem('authenticated');
                localStorage.removeItem('verified');
                localStorage.removeItem('access_token');
                localStorage.removeItem('bds123.user_data');
                window.location.href = logout_url;
			});
        },
        init:function(){
            this.userLogin();
            this.userRegister();
            this.forgotPassword();
            this.verifyAccount();
            this.lastActivity();
            this.rating();
            this.logout();
        },
    },
    zalo:{
        zalo_auth_url:'https://oauth.zaloapp.com/v3/auth',
        zalo_auth_access_token_url:'https://oauth.zaloapp.com/v3/access_token',
        profile_info_url:'https://graph.zalo.me/v2.0/me',
        profile_fields:'id,name,birthday,picture,gender',
        app_id:'1335178115962515915',
        app_secret:'VFjoIsD0T4J1UICN5vDK',
        return_url:'https://bds123.vn/callback/zalo',
        zalo_auth_code:false,
        zalo_access_token:false,
        getParameterByName: function (name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
        getAccessToken: function(){
            var self = this;
            if(!self.zalo_auth_code) return;
            $.ajax({
                url: self.zalo_auth_access_token_url+'?app_id='+self.app_id+'&app_secret='+self.app_secret+'&code='+self.zalo_auth_code,
                type: 'GET',
                success:function(response){
                    // console.log(response);
                }
            });
        },
        getUserInfo: function(){
            var self = this;
            if(self.zalo_access_token) return;

            $.ajax({
                url: self.profile_info_url+'?app_access_tokenid='+self.zalo_access_token+'&fields='+self.profile_fields,
                type: 'GET',
                success:function(response){
                    // console.log(response);
                }
            });
        },
        login:function(){
            var self = this;
            $('.js-login-zalo').on('click', function(event){
                event.preventDefault();

                Zalo.getLoginStatus(function(response) {
                    if (response.status === 'connected') {
                        Zalo.api('/me',
                            'GET',
                            {
                                fields: 'id,name'
                            },
                            function (response) {
                                // console.log(response);
                            }
                        );
                    } else {
                        Zalo.login();
                    }
                });
            });
        },
        init:function(){
            this.login();
        }
	},
	accountKit:{
		loginCallback: function(response) {
			if (response.status === 'PARTIALLY_AUTHENTICATED') {
				$('.js-login-form-sms').find('.code').val(response.code);
				$('meta[name="_token"]').attr('content', response.state);

				toastr.info('Đăng nhập thành công.');
				if (self.is_requesting) return;
				self.is_requesting = true;

				var action_url = $('.js-login-form-sms').attr('data-action-url');
				if (!action_url) return;

				var _self = $('.js-login-form-sms');

				$.ajax({
					url: action_url,
					data: _self.serialize(),
					type: 'POST',
					dataType: 'json',
					beforeSend: function () {
						_self.find('.js-btn-hoan-tat').text('Đang xử lí...');
					},
					success: function (data) {
						self.is_requesting = false;
					},
					error: function (data) {
						self.is_requesting = false;
					}
				});
			}else if (response.status === 'NOT_AUTHENTICATED') {
				// handle authentication failure
				toastr.info('Đăng nhập không thành công.');
			}else if (response.status === 'BAD_PARAMS') {
				// handle bad parameters
				toastr.info('Bạn vui lòng kiểm tra thông tin và thử lại.');
			}
		},
		smsLogin: function(){
			var countryCode = '+84';
			var phoneNumber = $('.js-login-form-sms').find('.phone').val();
			if(phoneNumber.substr('0',1) === '0'){
				phoneNumber = phoneNumber.substr(1, 9);
			}
			if(phoneNumber.substr(0, 2) === '84'){
				phoneNumber = '+'+phoneNumber;
			}

			phoneNumber = phoneNumber.replace(/\s/g,'');
			phoneNumber = phoneNumber.replace('+','');

			AccountKit.login(
				'PHONE',
				{countryCode: countryCode, phoneNumber: phoneNumber},
				this.loginCallback
			);
		},
		init: function(){
			var self = this;
			$('.js-login-form-sms').find('.js-btn-hoan-tat').on('click', function(e){
				e.preventDefault();

				if($(this).hasClass('disabled')) return;
				self.smsLogin();
			});
		}
	},
	isOnScreen: function(elem) {
		// if the element doesn't exist, abort
		if( elem.length == 0 ) {
			return;
		}
		var $window = $(window);
		var viewport_top = $window.scrollTop();
		var viewport_height = $window.height();
		var viewport_bottom = viewport_top + viewport_height;

		// var $elem = $(elem)
		var top = elem.offset().top;

		var height = elem.height();
		var bottom = top + height;

		return (top >= viewport_top && top < viewport_bottom) ||
		(bottom > viewport_top && bottom <= viewport_bottom) ||
		(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    },
    positionAdFixed: function() {
        var bodywidth = 1040;
        var widthleft = $('#ad-left-fixed').width();
        var widthright = $('#ad-right-fixed').width();
        var xright = (($(document).width() - bodywidth) / 2) + bodywidth;
        var xleft = (($(document).width() - bodywidth) / 2) - widthleft;
        if ($(document.body).width() < bodywidth + widthleft + widthright) {
            $('.banner_fixed').css('display', 'none');
            return;
        } else {
            $('.banner_fixed').css('display', 'block');
        }

        xleft = (($(document.body).width() - 0 - bodywidth) / 2) - widthleft - 30;

        $('#ad-left-fixed').css({ left: xleft + 'px' });

        $('#ad-right-fixed').css({ right: xleft + 'px' });
    },
	layoutFront: function () {
        var self = this;

		var myPlayer = false;
		if($('#my-video').length && !myPlayer){
            myPlayer = document.getElementById('my-video');
        }

        if($('#Modal_Video').length){
            var canvasVideo = document.getElementById('Modal_Video')
            canvasVideo.addEventListener('hide.bs.modal', function () {
                if(myPlayer){
                    myPlayer.pause();
                }

                if($('#video-yt-in-post').length){
                    $('#video-yt-in-post')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                    $('#video-yt-in-post')[0].contentWindow.postMessage({type: 'pause', 'x-tiktok-player': true}, '*');
                };
                $('.js-video-youtube').each(function(index, el){
                    $(this)[index].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                    $(this)[index].contentWindow.postMessage({type: 'pause', 'x-tiktok-player': true}, '*');
                });

            });
        }

        if($('#carousel_Photos').length){
            var carouselPhotos = document.getElementById('carousel_Photos');
            carouselPhotos.addEventListener('slide.bs.carousel', function () {
                if($('#video-display-in-post').length){
                    document.getElementById('video-display-in-post').pause();
                }
                if(myPlayer){
                    myPlayer.pause();
                }

                if($('#video-yt-in-post').length){
                    $('#video-yt-in-post')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                    $('#video-yt-in-post')[0].contentWindow.postMessage({type: 'pause', 'x-tiktok-player': true}, '*');
                };
                $('.js-video-youtube').each(function(index, el){
                    $(this)[index].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
                    $(this)[index].contentWindow.postMessage({type: 'pause', 'x-tiktok-player': true}, '*');
                });
            });
        }

        $(window).resize(function () {
            self.positionAdFixed();
        });
        self.positionAdFixed();

		if(typeof Sticky !== 'undefined'){

			if ($('.js-author-sticky').length) {
				new Sticky('.js-author-sticky');
			}
			if ($('.js-articles-sticky').length) {
				new Sticky('.js-articles-sticky');
			}
			if ($('.js-bar-sticky').length) {
				new Sticky('.js-bar-sticky');
			}
		}

        if ($('.js-share-link-button').length) {
            var copylink_clipboard = new ClipboardJS('.js-share-link-button', {
                container: document.getElementById('offcanvasShare')
            });
            copylink_clipboard.on('success', function (e) {
                $('.js-share-link-button').find('span').text('Đã sao chép');
                setTimeout(function () {
                    $('.js-share-link-button').find('span').text('Sao chép');
                }, 1000);
            });
        }

		/* TOC */
		$('.js-toc-list a').on('click', function(e){
            e.preventDefault();

            var id = $(this).attr('href');
            $('html, body').animate({
                scrollTop: ($(id).offset().top - 140) + 'px'
            }, 0);
        });

		$('.js-sort-post').on('click', function(event){
			// event.preventDefault();

            $(this).toggleClass('active');
			event.stopPropagation();
        });

        $(document).on('click', function() {
            $('.js-sort-post').removeClass('active');
        });


		$('.js-btn-go-link').on('click', function (event) {
			event.preventDefault();
			window.location.href = $(this).attr('data-href');
		});

		$('.js-go-to').on('click', function(e){
            e.preventDefault();

            var id = $(this).attr('data-href');
            $('html, body').animate({
                scrollTop: ($(id).offset().top - 110) + 'px'
            }, 'slow');
		});

		$('body').on('click', '.js-btn-back', function(e){
			var prev_div = $(this).attr('data-prev');
			if($(prev_div).length){
				e.preventDefault();
				$('.js-stage-step').removeClass('active');
				$(prev_div).addClass('active');
			}else{
				if (document.referrer.indexOf(window.location.host) !== -1){
					e.preventDefault();
					window.history.back();
					return;
				}
			}
        });

        let lastScrollTop = 0;
        window.addEventListener('scroll', function () {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > 0) {
                common_app.body.removeClass('top-0');
            } else {
                common_app.body.addClass('top-0');
            }

            if (scrollTop > lastScrollTop) {
                common_app.body.removeClass('scroll-up');
                common_app.body.addClass('scroll-down');
            } else if (scrollTop < lastScrollTop) {
                common_app.body.removeClass('scroll-down');
                common_app.body.addClass('scroll-up');
            }

            lastScrollTop = scrollTop;
        });

		var user_data = false;
		var str_user_data = localStorage.getItem('bds123.user_data');
		if(str_user_data && typeof str_user_data !== 'undefined' && str_user_data != 'undefined'){
			user_data = JSON.parse(str_user_data);
		}

		// SCROLL
		$(window).scroll(function () {
			// if(!$('.js-post-viewed-wrap').hasClass('loaded') && self.isOnScreen($('.js-post-viewed-wrap'))){
			if($('.js-post-viewed-wrap').length > 0 && !$('.js-post-viewed-wrap').hasClass('loaded')){

				var _layout = $('.js-post-viewed-wrap').attr('data-layout') || 'grid';
				var _exclude_id = $('.js-post-viewed-wrap').attr('data-exclude-id') || '';
				$.ajax({
					url: base_api_url + '/get/post/viewed',
					data: {
						token: $('meta[name="_token"]').attr('content'),
						layout:_layout,
						exclude_id:_exclude_id
					},
					type: 'POST',
					dataType: 'json',
					success: function(res){
						$('.js-post-viewed-inner').removeClass('hidden');
						$('.js-post-viewed-wrap').removeClass('hidden');
					}
				});
				$('.js-post-viewed-wrap').addClass('loaded');

			}

			if($('.js-post-newsed-wrap').length > 0 && !$('.js-post-newsed-wrap').hasClass('loaded')){

				var _layout = $('.js-post-newsed-wrap').attr('data-layout') || 'list';
				var estate_id = $('.js-post-newsed-wrap').attr('data-estate-id') || 41;

				$.ajax({
					url: base_api_url + '/get/post/newsed',
					data: {
						token: $('meta[name="_token"]').attr('content'),
						layout:_layout,
						estate_id:estate_id
					},
					type: 'POST',
					dataType: 'json',
					success: function(res){
						$('.js-post-newsed-inner').removeClass('hidden');
						$('.js-post-newsed-wrap').removeClass('hidden');
					}
				});
				$('.js-post-newsed-wrap').addClass('loaded');

			}


			if(user_data){
				var el_broken = $('.js-broken-action');
				if(el_broken.attr('data-broker-id') == user_data.id || user_data.manage_post){
					el_broken.removeClass('hidden');
				}


				if($('.js-post-saved-wrap').length > 0 && !$('.js-post-saved-wrap').hasClass('loaded')){

					var _layout = $('.js-post-saved-wrap').attr('data-layout') || 'grid';
					var _exclude_id = $('.js-post-saved-wrap').attr('data-exclude-id') || '';
					$.ajax({
						url: base_api_url + '/get/post/saved',
						data: {
							token: $('meta[name="_token"]').attr('content'),
							layout:_layout,
							exclude_id:_exclude_id
						},
						type: 'POST',
						dataType: 'json',
						success: function(res){
							$('.js-post-saved-inner').removeClass('hidden');
							$('.js-post-saved-wrap').removeClass('hidden');
						}
					});

					$('.js-post-saved-wrap').addClass('loaded');
				}
			}

		});

        $('.js-lbk-tab-item').on('click', function(e){
            var tab_index = $(this).attr('data-lbk-tab');
            $('.js-lbk-tab-item').removeClass('active');
            $(this).addClass('active');
            $('.js-lbk-tab-panel').removeClass('active');
            $('#js-lbk-tab-panel-' + tab_index).addClass('active');
        });

        $('.js-btn-readmore').on('click', function(e){
            e.preventDefault();
            $('.js-bottom-content').toggleClass('has-readmore');
            var readmore_text = $('.js-btn-readmore').text();
            $('.js-btn-readmore').text(
                readmore_text == 'Thu gọn' ? 'Xem thêm' : 'Thu gọn');
        });

		$('.js-view-all-location').on('click', function(e){
			e.preventDefault();

			var myBody = document.getElementsByTagName('body')[0];
			myBody.classList.toggle('show-filter-popup');

			$('.js-filter-popup-city').addClass('show');
		});

		$('.js-slect-filter').change(function(){
			window.location.href = $(this).val();
		});

		// FAQ
		$('.js-accordion-button').on('click', function (e) {
            e.preventDefault();

            var data_accordion_target = $(this).attr('data-accordion-target');
            $(this).toggleClass('active');
            $('#' + data_accordion_target).toggleClass('show');
        });
	},
	processSubmitFormFront: function () {
		var self = this;

		$('.js-form-submit-data button[type="submit"]').on('click', function(e){
			e.preventDefault();

			if($(this).closest('form').valid()){
				$(this).closest('form').submit();
			}
		});

		$('.js-form-submit-data.validate').each(function(index, el){
			$(el).validate();
		});
		$('.js-form-submit-data').each(function(index, el){

			$(el).on('submit', function (event) {
				event.preventDefault();
				if (self.is_requesting) return;
				self.is_requesting = true;

				var action_url = $(this).attr('data-action-url');
				if (!action_url) return;

				var _self = $(this);
				var _button_text = _self.find('.js-btn-hoan-tat').html();

				$.ajax({
					url: action_url,
					data: _self.serialize(),
					type: 'POST',
					dataType: 'json',
					beforeSend: function () {
						_self.find('.js-btn-hoan-tat').html('Đang xử lí...');
					},
					success: function (data) {
						_self.find('.js-btn-hoan-tat').html(_button_text);
						self.is_requesting = false;
					},
					error: function (data) {
						self.is_requesting = false;
					}
				});
			});
		});

	},
	filterArray :function(array, object, key) {
		// var index = array.findIndex(o => o[key] === object[key]);
		var index = array.findIndex(function(o){
			return o[key] === object[key]
		});
		if (index === -1) {
			array.push(object);
		}else {
			array.splice(index, 1);
		}
		return array;
	},
	postLikable: function () {
		var self = this;
		$(front_app.body).on('click', '.js-btn-save', function (e) {
			e.preventDefault();

			var _self = $(this);
			var post_id = $(this).attr('data-post-id');
			var status = 'saved';
			if (_self.hasClass('saved')) {
				status = 'unsaved';
			}

			// không show loading
			window.show_loading = false;
			// var authenticated = localStorage.getItem('authenticated');
			// if(authenticated){
				$.ajax({
					url: base_url + '/api/post/save',
					data: {
						post_id: post_id,
						action: status,
						referer_url:window.location.href
					},
					type: 'POST',
					dataType: 'json',
					success: function (data) {
						$('.js-btn-save[data-post-id="'+post_id+'"]').find('span').html(data.button_text);
						$('.js-btn-save[data-post-id="'+post_id+'"]').attr('data-original-title', data.button_text);

						// add class save
						if (status == 'saved') {
							$('.js-btn-save[data-post-id="'+post_id+'"]').addClass('saved');
						} else {
							$('.js-btn-save[data-post-id="'+post_id+'"]').removeClass('saved');
							if(front_app.body.hasClass('page-post-saved') && _self.closest('article').length){
								_self.closest('article').fadeOut(1000, function () {
									$(this).remove();
								});
							}
						}
						$('.js-save-post-total').html(data.total_post_like);
						if(data.total_post_like == 0){
							$('.js-save-post-total').addClass('hidden');
						}else{
							$('.js-save-post-total').removeClass('hidden');
						}
					}
				});
			// }else{
			// 	var str_post_favorist = localStorage.getItem('post_favorist');
			// 	if(str_post_favorist && typeof str_post_favorist !== 'undefined'){
			// 		common_app.post_favorists = JSON.parse(str_post_favorist);
			// 	}

			// 	var d = new Date();
			// 	var post_favorist_item = {
			// 		'post_id': post_id,
			// 		'created_at': d.getFullYear() + '-' + ('0'+(d.getMonth() + 1)).slice(-2) + '-' + ('0'+d.getDate()).slice(-2) + ' ' + ('0'+d.getHours()).slice(-2)  + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0'+d.getSeconds()).slice(-2)
			// 	};
			// 	self.filterArray(common_app.post_favorists, post_favorist_item, 'post_id');
			// 	var str_post_favorist = localStorage.setItem('post_favorist', JSON.stringify(common_app.post_favorists));
			// 	if (status == 'saved') {
			// 		$('.js-btn-save[data-post-id="'+post_id+'"]').addClass('saved');
			// 		$('.js-btn-save[data-post-id="'+post_id+'"]').find('span').html('Tin đã lưu');
			// 	} else {
			// 		$('.js-btn-save[data-post-id="'+post_id+'"]').removeClass('saved');
			// 		$('.js-btn-save[data-post-id="'+post_id+'"]').find('span').html('Lưu tin này');
			// 		if(front_app.body.hasClass('page-post-saved') && _self.closest('article').length){
			// 			_self.closest('article').fadeOut(1000, function () {
			// 				$(this).remove();
			// 			});
			// 		}
			// 	}
			// 	$('.js-save-post-total').html(common_app.post_favorists.length);
			// 	if(common_app.post_favorists.length == 0){
			// 		$('.js-save-post-total').addClass('hidden');
			// 	}else{
			// 		$('.js-save-post-total').removeClass('hidden');
			// 	}
			// }

		});
	},
	reloadPostSaved: function () {
        if($('.js-btn-save').length == 0 && $('.js-list-user-post-save').length == 0) return;

		var authenticated = localStorage.getItem('authenticated');
		var data_post_ids = [];
		$('.js-btn-save').each(function (index, el) {
			var post_id = $(el).attr('data-post-id');
			if (data_post_ids.indexOf(post_id) < 0) {
				data_post_ids.push(post_id);
			}
		});
		if(authenticated){
			$.ajax({
				url: base_url + '/api/post/check/save',
				data: {
					data_post_ids: data_post_ids
				},
				type: 'POST',
				dataType: 'json'
			});
		}else{
			$.ajax({
				url: base_url + '/api/post/view/count',
				data: {
					data_post_ids: data_post_ids
				},
				type: 'POST',
				dataType: 'json'
			});

			var str_post_favorist = localStorage.getItem('post_favorist');
			if(str_post_favorist && typeof str_post_favorist !== 'undefined'){
				common_app.post_favorists = JSON.parse(str_post_favorist);
				$('.js-save-post-total').html(common_app.post_favorists.length);
				if(common_app.post_favorists.length == 0){
					$('.js-save-post-total').closest('li').addClass('hidden');
				}
			}
			if(common_app.post_favorists.length && common_app.post_favorists.length){
				$('.js-btn-save').each(function (index, el) {
					for(var i = 0; i<common_app.post_favorists.length; i++){
						if($(el).attr('data-post-id') == common_app.post_favorists[i].post_id){
							$(el).addClass('saved');
							$(el).find('span').html('Tin đã lưu');
						}
					}
				});
			}

			if($('.js-list-user-post-save').length){
				var fav_data_post_ids = [];
				if(common_app.post_favorists.length && common_app.post_favorists.length){
					for(var i = 0; i<common_app.post_favorists.length; i++){
						fav_data_post_ids.push(common_app.post_favorists[i].post_id);
					}
				}
				var paged = common_app.search.getParameterByName('page') || 1;
				$.ajax({
					url: base_url + '/api/post/get/favorites',
					data: {
						post_ids: fav_data_post_ids,
						page:paged
					},
					type: 'POST',
					dataType: 'json'
				});
			}
		}

	},
	reloadHtmlHeader: function () {
		if($('.js-header-control-user-login').length == 0) return;

		var self = this;
		var action_url = base_url + '/api/refresh/header';

		var layout = self.body.attr('data-layout') || 'desktop';
		$.ajax({
			url: action_url,
			data: {
				layout: layout,
				page_type:front_app.body.data('type'),
				object_id:front_app.body.data('id')
			},
			xhrFields: {
				withCredentials: true
			},
			type: 'POST',
			dataType: 'json'
		});
    },
	fixFacebookLogin: function () {
		if (!window.location.hash || window.location.hash !== '#_=_')
			return;
		if (window.history && window.history.replaceState)
			return window.history.replaceState('', document.title, window.location.pathname + window.location.search);
		// Prevent scrolling by storing the page's current scroll offset
		var scroll = {
			top: document.body.scrollTop,
			left: document.body.scrollLeft
		};
		window.location.hash = '';
		// Restore the scroll offset, should be flicker free
		document.body.scrollTop = scroll.top;
		document.body.scrollLeft = scroll.left;
	},
	position_ads_Fixed: function () {
		var limit_width = $('#main').width() || 1100;
		var _padding = 50;
		var window_width = $(document).width();
		var bodywidth = $(document.body).width();
		var widthleft = $('.js-ad-fixed-left').width();
		var widthright = $('.js-ad-fixed-right').width();
		var xright = window_width > bodywidth ? ((window_width - bodywidth) / 2) + widthright/2 -_padding/2 : _padding/2;
		var xleft = window_width > bodywidth ? ((window_width - bodywidth) / 2) + widthleft/2 - _padding/2 : _padding/2;

		if (bodywidth < limit_width + widthleft + widthright + _padding) {
			$('.js-ad-fixed-position').css('display', 'none');
			// return;
		} else {
			$('.js-ad-fixed-position').css('display', 'block');
		}

		// xleft = (($(document.body).width() - 0 - bodywidth) / 2) - widthleft - 25;

		$('.js-ad-fixed-left').css({ left: xleft + 'px' });
		$('.js-ad-fixed-right').css({ right: xright + 'px' });
	},
	chart:{
		loan_config: false,
		loan_chart: false,
		pay_config: false,
		pay_chart: false,
		tra_truoc_percent: $('.js-so-tien-vay-percent').val() || 70, // %
		tien_tra_truoc: 0, // 0
		tien_vay: 0, // 0
		tien_lai_phai_tra: 0, // 0
		tong_tien_phai_tra: 0, // %
		thoi_gian_vay: $('.js-thoi-gian-value').val() || 5, // year
		lai_suat: $('.js-lai-xuat-vay-value').val() || 8.0, // %
		loai_lai_suat: $('.js-loai-lai-suat:checked').val() || 2, // %
		lai_thang_dau_phai_tra: 0, // %
		goc_thang_dau_phai_tra: 0, // %
		tong_tien_thang_dau_phai_tra: 0, // %
		gia_bds: $('.js-gia-bds').val() || 1000000000,
		chart_vay_data: [],
		chart_vay_data_money: [],
		chart_tien_tra_hang_thang_data: [],
		chart_tien_tra_hang_thang_money: [],
		removeZeroes: function(num) {
			var value = Number(num);
			value = value.toFixed(2);
			var res = value.toString().split('.');
			if(res.length > 1 && res[1] === '00'){
				return res[0];
			}
			if(res.length > 1 && res[1][1] ==='0'){
				return res[0]+'.'+res[1][0];
			}
			return value;
		},
		doc_so: function(number){
			if(number >= 1000000000){
				return this.removeZeroes(number*1.0/1000000000) + ' tỷ';
			}
			if(number >= 1000000){
				return this.removeZeroes(number*1.0/1000000)+ ' triệu';
			}
			if(number > 0 && number < 1000000){
				return this.removeZeroes(number*1.0/1000) + ' ngàn';
			}
			return '0 đồng';

		},
		calculatorLoan: function(){
			var self = this;

			self.chart_vay_data = [];
			self.chart_vay_data_money = [];
			self.chart_tien_tra_hang_thang_data = [];
			self.chart_tien_tra_hang_thang_money = [];
			// format laị giá cho chắc
			self.gia_bds = self.gia_bds.replace(/\./g,'');
			// tiền trả trước
			self.tien_tra_truoc = parseInt(self.gia_bds - self.gia_bds * self.tra_truoc_percent/100);
			// tiền phải vay
			self.tien_vay = parseInt(self.gia_bds - self.tien_tra_truoc);
			// thời gian vay
			var month = self.thoi_gian_vay * 12;
			// tiền gốc tháng đầu phải trả
			self.goc_thang_dau_phai_tra = parseInt(self.tien_vay/month);
			// tiền lãi tháng đầu phải trả
			self.lai_thang_dau_phai_tra = parseInt((self.tien_vay * self.lai_suat *1.0/100)/12);
			// tổng tiền tháng đầu phải trả
			self.tong_tien_thang_dau_phai_tra = self.goc_thang_dau_phai_tra + self.lai_thang_dau_phai_tra;
			// lãi theo dư nợ ban đầu
			if(self.loai_lai_suat == 2){
				// tổng tiền lãi phải trả
				self.tien_lai_phai_tra = parseInt(self.lai_thang_dau_phai_tra * month);
				// tổng tiền phải trả
				self.tong_tien_phai_tra = parseInt(self.tien_lai_phai_tra + self.tien_vay + self.tien_tra_truoc)
			}else{
				// lãi theo dư nợ giảm dần
				self.tien_lai_phai_tra = 0;
				for(i = 1; i<=month;i++){
					self.tien_lai_phai_tra += parseInt(((self.tien_vay - self.goc_thang_dau_phai_tra*(i-1))*self.lai_suat*1.0/100)/12);
				}
				self.tong_tien_phai_tra = parseInt(self.tien_lai_phai_tra + self.tien_vay + self.tien_tra_truoc)
			}
			// tính toán % tổng tiền phải trả
			var tra_truoc_percent = parseInt(self.tien_tra_truoc/ self.tong_tien_phai_tra * 100);
			var vay_percent = parseInt(self.tien_vay/ self.tong_tien_phai_tra * 100);
			var lai_percent = 100 - tra_truoc_percent - vay_percent;

			// update lại data cho chart
			self.chart_vay_data.push(tra_truoc_percent);
			self.chart_vay_data.push(vay_percent);
			self.chart_vay_data.push(lai_percent);
			// thêm data để diễn giải cho dể xem
			self.chart_vay_data_money.push(self.doc_so(self.tien_tra_truoc));
			self.chart_vay_data_money.push(self.doc_so(self.tien_vay));
			self.chart_vay_data_money.push(self.doc_so(self.tien_lai_phai_tra));

			// update chart cho tiền trả hàng tháng
			var tien_lai_thang_dau_percent = (self.lai_thang_dau_phai_tra / self.tong_tien_thang_dau_phai_tra)*100;
			var tien_goc_percent = 100 - tien_lai_thang_dau_percent;
			self.chart_tien_tra_hang_thang_data.push(tien_goc_percent);
			self.chart_tien_tra_hang_thang_data.push(tien_lai_thang_dau_percent);

			self.chart_tien_tra_hang_thang_money.push(self.doc_so(self.goc_thang_dau_phai_tra))
			self.chart_tien_tra_hang_thang_money.push(self.doc_so(self.lai_thang_dau_phai_tra))

			// render lại chart
			if(self.loan_chart){
				self.loan_chart.options.elements.center.text = self.doc_so(self.tong_tien_phai_tra);
				self.loan_chart.data.datasets[0].data = self.chart_vay_data;
				self.loan_chart.data.datasets[0].data_money = self.chart_vay_data_money;
				self.loan_chart.update();
			}
			if(self.pay_chart){
				self.pay_chart.options.elements.center.text = self.doc_so(self.tong_tien_thang_dau_phai_tra);
				self.pay_chart.data.datasets[0].data = self.chart_tien_tra_hang_thang_data;
				self.pay_chart.data.datasets[0].data_money = self.chart_tien_tra_hang_thang_money;
				if(self.loai_lai_suat == 2){
					self.pay_chart.options.title.text = 'Tiền trả hàng tháng';
				}else{
					self.pay_chart.options.title.text = 'Tiền tháng đầu phải trả';
				}
				self.pay_chart.update();
			}

			// update lại ui
			$('.js-vay-thang-goc-phai-tra').html(self.doc_so(self.goc_thang_dau_phai_tra));
			$('.js-vay-thang-lai-phai-tra').html(self.doc_so(self.lai_thang_dau_phai_tra));
			$('.js-vay-tra-truoc').html(self.doc_so(self.tien_tra_truoc));
			$('.js-vay-goc-phai-tra').html(self.doc_so(self.tien_vay));
			$('.js-vay-lai-phai-tra').html(self.doc_so(self.tien_lai_phai_tra));

		},
		chartLoan: function(){
			var self = this;
			$('.js-price-text').html(self.doc_so(self.gia_bds));

			$('.js-gia-bds').donetyping(function(){
				self.gia_bds = $(this).val().replace(/\./g,'');
				if(isNaN(self.gia_bds)){
					self.gia_bds = 0;
					$('.js-price-text').html(self.doc_so(self.gia_bds));
					$(this).val(parseFloat(self.gia_bds).formatDot());
					self.calculatorLoan();
					return;
				}
				self.calculatorLoan();
				$('.js-price-text').html(self.doc_so(self.gia_bds) + ' đồng');
				$(this).val(parseFloat(self.gia_bds).formatDot());
			}, 200);

			$('.js-loai-lai-suat').on('change', function(){
				self.loai_lai_suat = $(this).val();
				self.calculatorLoan();
			});

			if ($('.js-mortgage-loan-range-slider').length) {
				$('.js-mortgage-loan-range-slider').ionRangeSlider({
					min: 10,
					max: 100,
                    from: 70,
                    postfix: '%',
					grid: true,
					skin: 'round',
					onChange: function(data){
						$('.js-so-tien-vay-percent').val(data.from);
						self.tra_truoc_percent = data.from;
						self.calculatorLoan();
					},
					onFinish: function(data){
					}
				});
			}

			if ($('.js-mortgage-year-range-slider').length) {
				$('.js-mortgage-year-range-slider').ionRangeSlider({
					min: 1,
					max: 35,
                    from: 5,
                    postfix: ' năm',
					grid: true,
					skin: 'round',
					onChange: function(data){
						$('.js-thoi-gian-value').val(data.from);
						self.thoi_gian_vay = data.from;
						self.calculatorLoan();
					},
					onFinish: function(data){
					}
				});
			}
			if ($('.js-mortgage-interest-range-slider').length) {
				$('.js-mortgage-interest-range-slider').ionRangeSlider({
					step: 0.1,
					min: 0,
					max: 20,
                    from: 8,
                    postfix: '%/năm',
					grid: true,
					skin: 'round',
					onChange: function(data){
						$('.js-lai-xuat-vay-value').val(data.from);
						self.lai_suat = data.from;
						self.calculatorLoan();
					},
					onFinish: function(data){
					}
				});
			}
			if ($('.js-mortgage-chart-monthly-payment').length) {
				self.pay_config = {
					type: 'doughnut',
					data: {
						labels: ['Tiền gốc', 'Tiền lãi'],
						datasets: [{
							data: self.chart_tien_tra_hang_thang_data,
							data_money: self.chart_tien_tra_hang_thang_money,
                            backgroundColor: ['#006cfa', '#FF71B6'],
                            borderColor: ['#006cfa','#FF71B6' ],
                            borderWidth: 0,
							hoverBorderWidth: 2,
						}]
					},
					options: {
						responsive: true,
						legend: {
							display: false,
							position: 'bottom',
							reverse: true,
							labels: {
								padding: 10,
								fontSize: 12,
								fontColor: 'rgb(0, 0, 0)',
								pointStyle: 'circle',
								borderRadius: 5,
								boxWidth: 10,
								boxHeight: 10,
							}
						},
						tooltips: {
							enabled: true,
							callbacks: {
								title: function(tooltipItem, data) {
									return data['labels'][tooltipItem[0]['index']];
								},
								label: function(tooltipItem, data) {
									return ' '+data['datasets'][0]['data_money'][tooltipItem['index']];
									// return false;
								},
								afterLabel: function(tooltipItem, data) {
									// var dataset = data['datasets'][0];
									// var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
									// return '(' + percent + '%)';
									return '';
								}
							},
						},
						cutoutPercentage: 90,
						rotation: -0.5 * Math.PI,
						circumference: 2 * Math.PI,
						title: {
							display: true,
							text: 'Tiền tháng đầu phải trả'
						},
						animation: {
							animateScale: true,
							animateRotate: true
						},
						elements: {
							center: {
								maxText: '100%',
								text: self.doc_so(self.tong_tien_thang_dau_phai_tra),
								color: '#000000',
								fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
								fontStyle: '700',
								minFontSize: 1,
								maxFontSize: 256,
							}
						}
					}
				};

				var ctx = document.getElementsByClassName('js-mortgage-chart-monthly-payment');
				self.pay_chart = new Chart(ctx, self.pay_config);
			}
			if ($('.js-mortgage-chart-loan-rate').length) {
				self.loan_config = {
					type: 'doughnut',
					data: {
						labels: ['Tiền trả trước', 'Tiền vay', 'Tiền lãi'],
						datasets: [{
							// data: [75, 15, 10],
							data: self.chart_vay_data,
							data_money: self.chart_vay_data_money,
							backgroundColor: ['#cddc39','#006cfa', '#FF71B6' ],
							borderWidth: 0,
							borderColor: ['#cddc39','#006cfa', '#FF71B6' ],
							hoverBorderWidth: 2,
						}]
					},
					options: {
						responsive: true,
						legend: {
							display: false,
							position: 'bottom',
							reverse: true,
							labels: {
								padding: 10,
								fontSize: 12,
								fontColor: 'rgb(0, 0, 0)',
								pointStyle: 'circle',
								borderRadius: 5,
								boxWidth: 10,
								boxHeight: 10,
							}
						},
						tooltips: {
							enabled: true,
							callbacks: {
								title: function(tooltipItem, data) {
									return data['labels'][tooltipItem[0]['index']];
								},
								label: function(tooltipItem, data) {
									return ' '+data['datasets'][0]['data_money'][tooltipItem['index']];
									// return false;
								},
								afterLabel: function(tooltipItem, data) {
									return '';
									// return '(' + data['datasets'][0]['data'][tooltipItem['index']] + '%)';
								}
							},
						},
						cutoutPercentage: 90,
						rotation: -0.5 * Math.PI,
						circumference: 2 * Math.PI,
						title: {
							display: true,
							text: 'Tổng tiền phải trả'
						},
						animation: {
							animateScale: true,
							animateRotate: true
						},
						elements: {
							center: {
								maxText: '100%',
								text: self.doc_so(self.tong_tien_phai_tra),
								color: '#000',
								fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
								fontStyle: 'bold',
								minFontSize: 1,
								maxFontSize: 256,
							}
						}
					}
				};
				var ctx = document.getElementsByClassName('js-mortgage-chart-loan-rate');
				self.loan_chart = new Chart(ctx, self.loan_config);
			}
		},
		init: function(){
			if(typeof Chart === 'undefined') return;

			Chart.pluginService.register({
				beforeDraw: function(chart) {
					if (chart.config.options.elements.center) {
						// Get ctx from string
						var ctx = chart.chart.ctx;

						// Get options from the center object in options
						var centerConfig = chart.config.options.elements.center;
						var fontStyle = centerConfig.fontFamily || 'Arial';
						var txt = centerConfig.text;
						var color = centerConfig.color || '#000';
						var maxFontSize = centerConfig.maxFontSize || 75;
						var sidePadding = centerConfig.sidePadding || 20;
						var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
						// Start with a base font of 30px
						ctx.font = '40px ' + fontStyle;

						// Get the width of the string and also the width of the element minus 10 to give it 5px side padding
						var stringWidth = ctx.measureText(txt).width;
						var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

						// Find out how much the font can grow in width.
						var widthRatio = elementWidth / stringWidth;
						var newFontSize = Math.floor(30 * widthRatio);
						var elementHeight = (chart.innerRadius * 2);

						// Pick a new font size so it will not be larger than the height of label.
						var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
						var minFontSize = centerConfig.minFontSize;
						var lineHeight = centerConfig.lineHeight || 25;
						var wrapText = false;

						if (minFontSize === undefined) {
							minFontSize = 20;
						}

						if (minFontSize && fontSizeToUse < minFontSize) {
							fontSizeToUse = minFontSize;
							wrapText = true;
						}

						// Set font settings to draw it correctly.
						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';
						var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
						var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
						ctx.font = fontSizeToUse + 'px ' + fontStyle;
						ctx.fillStyle = color;

						if (!wrapText) {
							ctx.fillText(txt, centerX, centerY);
							return;
						}

						var words = txt.split(' ');
						var line = '';
						var lines = [];

						// Break words up into multiple lines if necessary
						for (var n = 0; n < words.length; n++) {
							var testLine = line + words[n] + ' ';
							var metrics = ctx.measureText(testLine);
							var testWidth = metrics.width;
							if (testWidth > elementWidth && n > 0) {
							lines.push(line);
							line = words[n] + ' ';
							} else {
							line = testLine;
							}
						}

						// Move the center up depending on line height and number of lines
						centerY -= (lines.length / 2) * lineHeight;

						for (var n = 0; n < lines.length; n++) {
							ctx.fillText(lines[n], centerX, centerY);
							centerY += lineHeight;
						}
						//Draw text in center
						ctx.fillText(line, centerX, centerY);
					}
				}
			});

			this.calculatorLoan();
			this.chartLoan();
		}
	},
	init: function () {
        this.user.init();
		this.layoutFront();
		this.position_ads_Fixed();
		this.fixFacebookLogin();
		this.processSubmitFormFront();
		this.postLikable();
		this.zalo.init();
        this.accountKit.init();
        this.reloadHtmlHeader();
	    this.reloadPostSaved();
		this.chart.init();
	}
};

$(document).ready(function () {

	var jBody = $(document.body);

	if (jBody.hasClass('loaded')) return;
    jBody.addClass('loaded');

	front_app.init();

	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
		}
	});
});
